import React from "react";
import "./alltop.css";

const AllTop = () => {
  return (
    <>
      <div className="all-top-container">
        <h2 className="section-title">We Offer</h2>
        <div className="image-grid">
          <div className="image-card">
            <img
              src="./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/38.png"
              alt="Printed Shirts"
              className="image"
            />
            <p className="caption">Variety of Sports</p>
            <p className="product-details">
              MRG Multi-sport clubs offer a range of sports, accommodating
              diverse interests and skill levels.{" "}
            </p>
            {/* <p className="price">₹999</p> */}
          </div>
          <div className="image-card">
            <img
              src="./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/20.png"
              alt="Basics"
              className="image"
            />
            <p className="caption">Team Building</p>
            <p className="product-details">
              Our club provide opportunities for team bonding through sports,
              which can be especially beneficial in corporate settings
            </p>
            {/* <p className="price">₹799</p> */}
          </div>
          <div className="image-card">
            <img
              src="./assets/images/cricket/gallery4.jpeg"
              alt="Baggy Fit"
              className="image"
            />
            <p className="caption">Skill Development</p>
            <p className="product-details">
              MRG Multi-sport events focus on introducing activities, improving
              fitness, teaching new skills, and fostering friendships
            </p>
            {/* <p className="price">₹1,299</p> */}
          </div>
          <div className="image-card">
            <img
              src="./assets/WEBSITE IMAGES/YOUTH ICON SKATING CHAMPIONSHIP/12.png"
              alt="Solid Shirts"
              className="image"
            />
            <p className="caption">Event Management</p>
            <p className="product-details">
              MRG has hosted numerous cricket leagues and open championships,
              making it a recognized name in Rajasthan's sports community.
            </p>
            {/* <p className="price">₹899</p> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default AllTop;
